import React from 'react';

export const ChevronDownIcon = () => {
    return (
        <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0L4.16667 4.16667L8.33333 0H0Z" fill="white"/>
        </svg>
    );
};
